module.exports = __webpack_public_path__ + "static/media/Proximus-ExtraB.aa3904e6.woff";